import { TherapistAction } from "src/redux/actions/constant";

const intialState: object = {
  response: null,
  isGetTherapistTaskType: false,
  data: [],
  loading: false,
};

export const getAllTherapistTaskTypeReducer = (state = intialState, action: any) => {

  switch (action.type) {
    case TherapistAction.GET_ALL_TASK_TYPE_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isGetTherapistTaskType: true,
        data: action.payload.data,
        loading: false,
      };
    }
    case TherapistAction.GET_ALL_TASK_TYPE_FAILURE: {
      return {
        ...state,
        response: action.payload,
        isGetTherapistTaskType: false,
        loading: false,
      };
    }
    case TherapistAction.GET_ALL_TASK_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
